// Send-to-Etsy wire shape + helpers (server: app/api/v1/etsy_draft.py, P4).

export type PublishStep = {
  status: 'ok' | 'warn' | 'failed' | 'skipped' | 'uncertain'
  count?: number
  total?: number
  message?: string
  tags?: number
  materials?: number
  enabled?: number
  hidden?: number
  reused?: number
  uploaded?: number
  failed?: { rank: number; label: string | null; message: string }[]
  missing?: string[]
}

export type PublishView = {
  status: 'none' | 'pending' | 'in_progress' | 'sent' | 'partial' | 'uncertain' | 'failed' | string
  steps: Record<string, PublishStep>
  etsy_listing_id: string | null
  edit_url: string | null
  last_error: string | null
  updated_at?: string | null
}

export const STEP_ORDER = [
  'listing',
  'photos',
  'options',
  'variation_photos',
  'personalization',
  'binding',
] as const

export const publishKey = (listingId: string) => ['seller', 'listings', listingId, 'etsy-publish'] as const

export const isRunning = (s: PublishView['status']) => s === 'pending' || s === 'in_progress'
export const isSent = (s: PublishView['status']) => s === 'sent' || s === 'partial'

export const ETSY_DRAFTS_URL = 'https://www.etsy.com/your/shops/me/tools/listings/state:draft'
